module.exports = __webpack_public_path__ + "img/DK.c0cd6347.svg";